import React from 'react';
import {
  TextField,
  Box,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

const Generator = () => {
  return (
    <>
      <Box>
        <InputLabel id="demo-simple-select-label">Почта отправителя</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={10}
          label="Age"
        >
          <MenuItem value={10}>info@gold-race.org</MenuItem>
          <MenuItem value={20}>finances@gold-race.org</MenuItem>
        </Select>
      </Box>
      <Box mt={3}>
        <TextField id="outlined-basic" label="Тема письма" variant="outlined" />
      </Box>
      <Box mt={3}>
        <InputLabel id="demo-simple-select-label">Ссылка на баннер</InputLabel>
        <TextField
          id="outlined-basic"
          placeholder="https://..."
          variant="outlined"
        />
      </Box>
      <Box mt={3}>
        <TextField
          id="outlined-multiline-static"
          label="Текст письма"
          multiline
          rows={10}
        />
      </Box>
    </>
  );
};

export default Generator;
